const HTTP_ERROR_NEED_LOGOUT = 405;
const HTTP_DATABASE_ERROR = 406;

export {
    HTTP_ERROR_NEED_LOGOUT,
    HTTP_DATABASE_ERROR
};
